import { useAlterarConfiguracaoCadastroIndividualViaCdsMutation } from 'graphql/hooks.generated'

import { ConfiguracaoBooleanBox } from '../ConfiguracaoBooleanBox'

interface ConfiguracoesBloqueioFciViaCdsBoxProps {
  habilitado: boolean
}

export function ConfiguracoesBloqueioFciViaCdsBox({ habilitado }: Readonly<ConfiguracoesBloqueioFciViaCdsBoxProps>) {
  const [alterarConfiguracao] = useAlterarConfiguracaoCadastroIndividualViaCdsMutation()

  return (
    <ConfiguracaoBooleanBox
      title='Cadastros individuais via CDS'
      description='Pode comprometer a qualidade dos cadastros em relação à vinculação dos cidadãos. O novo módulo de Cadastro individual (antigo módulo do Cidadão) já substitui e otimiza esse fluxo, inibindo a ocorrência de inconsistências e facilitando a gestão dos cadastros.'
      habilitado={habilitado}
      modalBody='Isso pode aumentar a ocorrência de inconsistências na vinculação dos cidadãos. Recomendamos que, ao invés disso, o município utilize o módulo de Cadastro individual, que provê todas as funcionalidades que existiam no CDS e ainda fornece meios para qualificação dos cadastros.'
      successMsgHabilitado='Cadastros individuais via CDS habilitadas com sucesso'
      successMsgDesabilitado='Cadastros individuais via CDS desabilitadas com sucesso'
      onMutation={(input) => alterarConfiguracao({ variables: { input } })}
    />
  )
}
